import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'fe-precheckin-progress',
    templateUrl: './precheckin-progress.component.html',
    styleUrls: ['./precheckin-progress.component.scss'],
})
export class PrecheckinProgressComponent {
    @Input() step: number | undefined = 0;

    codeReservation = '';
    progresItems: Array<any> = [];
    pathCode = '';
    dinamicUrl = 'registrado';
    dinamicStep1url = '';

    constructor(
        private readonly router: Router,
        private route: ActivatedRoute,
    ) {
        this.ngOnInit();
        this.constructProgressItems();
    }

    ngOnInit(): void {
        this.codeReservation = this.route.snapshot.paramMap.get(
            'resevationCode',
        ) as string;

        const url = this.router.url;

        const match = url.match(/\/(GRN\d+)(\/|$)/);

        if (match && match[1]) {
            this.pathCode = match[1];
        } else {
            this.pathCode = '';
        }

        if (this.pathCode != null) {
            this.dinamicStep1url = `es/pre-check-in/reservaciones/${this.codeReservation}`;
        } else {
            this.dinamicStep1url = `es/pre-check-in/reservaciones/`;
        }
    }

    constructProgressItems(): void {
        this.progresItems = [
            {
                index: 1,
                name: 'fe_precheckin_reservation_card_title',
                url: this.dinamicStep1url,
            },
            {
                index: 2,
                name: 'fe_precheckin_active_reservation_active_reservation_card_title',
                url: `es/pre-check-in/${this.dinamicUrl}/reservaciones/${this.codeReservation}/reservacion-activa`,
            },
            {
                index: 3,
                name: 'fe_precheckin_official_documents_card_title',
                url: `es/pre-check-in/${this.dinamicUrl}/reservaciones/${this.codeReservation}/documentos_oficiales`,
            },
            {
                index: 4,
                name: 'fe_precheckin_billing_data_content_container_choose_title',
                url: `es/pre-check-in/${this.codeReservation}/reservaciones/${this.codeReservation}/datos_facturacion`,
            },
        ];
    }
}
